import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Injectable({ providedIn: "root" })
export class ThemeService {
  private readonly linkId = "arena-theme";

  constructor(@Inject(DOCUMENT) private doc: Document) {}

  async applyTheme(themeName: string): Promise<void> {
    if (!themeName) themeName = "default";
    let href = ``;
    if (themeName === "default") {
      href = `assets/themes/dx.light.css`;
    } else {
      href = `assets/themes/dx.light.${themeName}.css`;
    }
    let linkEl = this.doc.getElementById(this.linkId) as HTMLLinkElement;

    if (!linkEl) {
      linkEl = this.doc.createElement("link");
      linkEl.id = this.linkId;
      linkEl.rel = "stylesheet";
      this.doc.head.appendChild(linkEl);
    }

    return new Promise<void>((resolve) => {
      linkEl.onload = () => resolve();
      linkEl.onerror = () => resolve(); // don’t break if file missing; silently continue
      linkEl.href = href;
    });
  }
}
